import React from 'react';

interface TrendIndicatorProps {
  value: number;
  inverse?: boolean;
}

// Trend Indicator Component
const TrendIndicator: React.FC<TrendIndicatorProps> = ({ value, inverse = false }) => {
  // Determine color and icon based on trend value
  // If inverse is true, negative values are good (e.g., for bug rates)
  const actualValue = inverse ? -value : value;
  
  let color = '#2196F3'; // neutral blue
  let icon = '→';
  
  if (actualValue > 15) {
    color = '#4caf50'; // strong positive - green
    icon = inverse ? '↓↓' : '↑↑';
  } else if (actualValue > 5) {
    color = '#8bc34a'; // positive - light green    
    icon = inverse ? '↓' : '↑';
  } else if (actualValue < -15) {
    color = '#f44336'; // strong negative - red    
    icon = inverse ? '↑↑' : '↓↓';
  } else if (actualValue < -5) {
    color = '#ff9800'; // negative - orange
    icon = inverse ? '↑' : '↓';
  }
  
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <span style={{ color, fontWeight: 'bold', fontSize: '16px' }}>{icon}</span>
      <span style={{ color, fontWeight: 'bold' }}>
        {value > 0 ? `+${value.toFixed(1)}%` : `${value.toFixed(1)}%`}
      </span>
    </div>
  );
};

export default TrendIndicator;
